module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "live-view-header container-fluid",
    style: (_vm.headerStyle)
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-auto"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), (_vm.name) ? _c('span', [_vm._v("–")]) : _vm._e(), _vm._v(" "), (_vm.name) ? _c('span', {
    staticClass: "state-name"
  }, [_vm._v(_vm._s(_vm.processstate.name))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "id"
  }, [_vm._v(_vm._s(_vm.id))])]), _vm._v(" "), _c('div', {
    staticClass: "col text-right"
  }, [(_vm.processstate.items.length) ? _c('erco-dropdown', {
    attrs: {
      "size": "sm",
      "label": _vm.dropdownLabel,
      "right": true,
      "items": _vm.processstate.items,
      "useLabelInline": true
    },
    on: {
      "change": _vm.handleStateChange
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon glyphicon glyphicon-home"
  }, [_c('a', {
    attrs: {
      "href": "/#/dashboard"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/home.svg")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02f27bdc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/ErcoLiveViewHeader.vue
// module id = 587
// module chunks = 0